import { useQuery } from 'react-query';
import { createFetchAPI } from '../http';
import { CompanyIdRequest } from './types';

const fetchCompanyOutlets = createFetchAPI<
  CompanyIdRequest,
  FetchCompanyOutletsResponse
>('v1/companies/outlets');

export const useFetchCompanyOutlets = ({ company_id }: CompanyIdRequest) =>
  useQuery<FetchCompanyOutletsResponse>(
    ['fetchCompanyOutlets', { company_id }],
    fetchCompanyOutlets,
  );

export type FetchCompanyOutletsResponse = {
  outlets: Outlet[];
};

type Outlet = {
  id: string;
  name: string;
  has_fave_payment: boolean;
  status: string;
  fave_fees: number;
};
